import { ContributoUnificato } from 'src/app/common/models/contributo-unificato';

export class ContributoUnificatoAdapter {

  contributoUnificato: ContributoUnificato = new ContributoUnificato();

  constructor(contributoUnificato: ContributoUnificato) {
    this.contributoUnificato.id = contributoUnificato.id;
    this.contributoUnificato.tipoContributo = contributoUnificato.tipoContributo;
    this.contributoUnificato.valoreImportoFisso = contributoUnificato.valoreImportoFisso;
    this.contributoUnificato.valoreScaglione = contributoUnificato.valoreScaglione;
    this.contributoUnificato.contributoCalcolato = contributoUnificato.contributoCalcolato;
  }
}


